import { useRef, useState } from 'react';
import s from './AllServices.module.scss'
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import useGetServiceTypes from 'sdk/hooks/salon/useGetServiceTypes';

interface AllServicesFilterProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
}

const AllServicesFilter = ({
  selectedCategory,
  setSelectedCategory
}: AllServicesFilterProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { data: serviceTypes } = useGetServiceTypes();

  const getCategoryName = (id: string) => {
    const category = serviceTypes?.find(cat => cat.id === id);
    return category?.name || 'All';
  };

  return (
    <div className={s.all_services_filter}>
      <div className={s.all_services_filter_title}>Category</div>
      <div
        className={s.all_services_filter_selection}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className={s.all_services_filter_selection_title}>
          {getCategoryName(selectedCategory)}
        </div>
        <div className={s.all_services_filter_selection_icon}>
          <IconArrow />
        </div>
      </div>
      {showDropdown && (
        <div className={s.dropdown_menu} ref={dropdownRef}>
          <div
            className={s.dropdown_item}
            onClick={() => {
              setSelectedCategory('all');
              setShowDropdown(false);
            }}
          >
            All
          </div>
          {serviceTypes?.map((category) => (
            <div
              key={category.id}
              className={s.dropdown_item}
              onClick={() => {
                setSelectedCategory(category.id);
                setShowDropdown(false);
              }}
            >
              {category.name}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default AllServicesFilter